import _ from 'lodash';
import { PRT_DETAIL_ACTIONS } from 'actions/protocols/protocoldetail';

export const createLoadingSelector = actions => state => _(actions).some(action => _.get(state, `loading.${action}/`));

export const createErrorMessageSelector = actions => state => (
  _(actions)
    .map(action => _.get(state, `error.${action}/`))
    .compact()
    .first() || ''
);

export const ProtocolIdSelector = state => state.prtDetails.prtInfo.prtId;
export const ProtocolNumSelector = state => state.prtDetails.prtInfo.protocolNumber;
/*
    RSSMOD-907: https://jira.westat.com/browse/RSSMOD-907
*/
export const ProtocolProcessStatusSelector = state => state.prtDetails.prtInfo.isStatusTransactionPending;

export const lSelectorGetProtDetails = createLoadingSelector([
  PRT_DETAIL_ACTIONS.GET_PROT_DETAILS
]);

export const eSelectorGetProtDetails = createErrorMessageSelector([
  PRT_DETAIL_ACTIONS.GET_PROT_DETAILS
]);

/*
    PROT-206, PROT-207: https://jira.westat.com/browse/PROT-206, https://jira.westat.com/browse/PROT-207
*/
export const IrbExemptSelector = state => state.prtDetails.prtInfo.isIrbExempt;
